import { observable, action } from 'mobx';
import { GoalsApi } from '../../../../apis/goals';
import { IdealCareer } from '../../../../types/goals';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';

export class IdealCareerPaneState {
    @observable idealCareer: RemoteResourceV3<IdealCareer> = RemoteResourceV3.loading();

    init() {
        this.loadIdealCareer();
    }

    @action.bound
    async loadIdealCareer() {
        updateRemoteResourceV3(this.idealCareer, (v) => (this.idealCareer = v), () => GoalsApi.findIdealCareer());
    }

    @action.bound
    async setIdealCareer(files) {
        if (files && files[0]) {
            const [file] = files;
            const formData = new FormData();
            formData.append('ideal_career', file);
            await GoalsApi.updateIdealCareer(formData);
            this.loadIdealCareer();
        }
    }
}
